/*
 * Copyright (c) 2008-present Sonatype, Inc.
 *
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/pro/attributions
 * Sonatype and Sonatype Nexus are trademarks of Sonatype, Inc. Apache Maven is a trademark of the Apache Foundation.
 * M2Eclipse is a trademark of the Eclipse Foundation. All other trademarks are the property of their respective owners.
 */
import Axios from 'axios';

import {ExtJS, TokenMachine} from '@sonatype/nexus-ui-plugin';

import UIStrings from '../../../../constants/UIStrings';

export default TokenMachine.withConfig({
      services: {
        resetToken: () => ExtJS.requestAuthenticationToken(UIStrings.USER_TOKEN.MESSAGES.RESET_AUTHENTICATION)
            .then(authToken =>
                Axios.delete(`/service/rest/internal/current-user/user-token?authToken=${btoa(authToken)}`)),
        accessToken: () => ExtJS.requestAuthenticationToken(UIStrings.USER_TOKEN.MESSAGES.ACCESS_AUTHENTICATION)
            .then(authToken =>
                Axios.get(`/service/rest/internal/current-user/user-token?authToken=${btoa(authToken)}`))
      }
    }
);
